import { defineStore } from 'pinia'
import Axios from 'axios'
import { useProcessoParadigmaStore } from "@/store/processoparadigma-store"

const BASE_URL = process.env.VUE_APP_BASE_URL || window.location.origin + "/"
const TEMA_URL = BASE_URL + "api/demandasrepetitivas/gruporepresentativo"
export const useGRStore = defineStore('gruporepresentativo', {
  state: () => ({
    temas: {},
    temasCount: 0,
    pages: {},
    tema: {},
    stgTema: {},

    numProcessoPJe: "",
    numeroUnicoTema: "",
    questao: "",
    situacao: 0,
    numeroProcesso: "",
    page: 1,
  }),
  getters: {
    all: state => state.temas,
  },
  actions: {
    async resetPagination() {
      this.pages = {}
    },
    async clearStg() {
      this.stgTema = {
        numeroTemaVinculado: null,
        dataCriacao: null,
        dataSituacaoGrupoRepresentativo: null,
        idSituacao: null,
        anotacoesNugep: null,
        alcanceSobrestamento: null,
        descricao: null,
        numero: "",
        statusEnvioBnp: false,
        statusEnvioPje: false,
        processosparadigma: []
      }
    },
    async fetchStg(id) {
      const tema = await this.fetch(id)
      Object.assign(this.stgTema, tema);
      return this.stgTema
    },
    async fetch(id) {
      const { data } = await Axios.get(TEMA_URL + "/" + id)
      const { grupoRepresentativo } = data
      this.temas = {
        ...this.temas, ...Object.fromEntries([[grupoRepresentativo.numero, grupoRepresentativo]])
      }
      return grupoRepresentativo

    },
    async fetchPage(page, rowsPerPage) {
      this.page = page || this.page || 1;
      this.rowsPerPage = rowsPerPage || this.rowsPerPage || 10;
      const { data } = await Axios.get(TEMA_URL + "?page=" + this.page + "&itensporpagina=" + this.rowsPerPage + "&numProcessoPJe=" + this.numProcessoPJe + "&numeroUnicoTema=" + this.numeroUnicoTema + "&questao=" + this.questao +  "&idSituacaoTema=" + this.situacao)
      const { listaDeGrupoRepresentativo, meta } = data
      this.temasCount = meta.totalGr;
      this.pages[`${this.page}`] = listaDeGrupoRepresentativo
      return listaDeGrupoRepresentativo
    },
    async saveStg() {
      const fields = [
        "numero",
        "dataCriacao",
        "dataSituacaoGrupoRepresentativo",
        "idSituacao",
        "anotacoesNugep",
        "alcanceSobrestamento",
        "descricao",
        "numeroTemaVinculado",
        "processosParadigma",
        "statusEnvioBnp",
        "statusEnvioPje"
      ];

      const filterFields = obj =>
        Object.fromEntries(
          Object.entries(obj).filter(e => fields.includes(e[0]))
        );
      const procStore = useProcessoParadigmaStore()
      const payload = filterFields({ ...this.stgTema, processosParadigma: procStore.all });
      const result = payload.numero ? await Axios.put(TEMA_URL, payload) : await Axios.post(TEMA_URL, payload)
      return result
    }
  },
})
